// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","844":"component---src-pages-privacy-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"65eecaeed792c4197b38","844":"f5bb0390c4fb5fda3168","883":"59080734e8da654770c2"}[chunkId] + ".js";
};